<div class="form-header">
  <span *ngIf="mode === 'patient' && patientId && patientId > 0"> Compass assignment for {{getPatientName()}}</span>
  <span *ngIf="mode === 'patient' && (!patientId || patientId < 1) && family"> Compass assignment for family {{family.identifier}}</span>
  <span *ngIf="mode === 'compass'"> Compass assignment for {{getCompassName()}}</span>
</div>

<div class="warning" *ngIf="mode === 'patient' && !bulkSubscriptions || bulkSubscriptions.length === 0">Patient is assigned to a provider that has no compass subscriptions! No assignments can be made.</div>

<form class="form-view" [formGroup]="assignmentForm" (ngSubmit)="onSubmitForm(assignmentForm)" >
  
<div class="dialog-container" >
  <div class="form-fields">
    <div class="field" *ngIf="mode === 'compass' && patientId === -1">
      <mat-form-field appearance="fill">
        <mat-label>Patient</mat-label>
        <input type="text"
              placeholder="Search for patient"
              matInput debounce 
              type="text" [delay]="500"
              (text)="patientSearchInputChanged($event)" 
              formControlName="patient"
              [matAutocomplete]="auto">
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="getPatientDisplay"  (optionSelected)="onPatientSelected($event)">
          <mat-option *ngFor="let patient of patients" [value]="patient">
            {{patient.identifier}} {{getPatientFriendlyName(patient)}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="field" *ngIf="mode === 'compass' && patientId > -1">
        <mat-label>Patient</mat-label><br>
        <mat-label *ngIf="patient">{{patient.identifier}} {{getPatientFriendlyName(patient)}}</mat-label>     
    </div>
    <div class="field" *ngIf="mode === 'patient' && (!patientId || patientId < 1) && family">
      <mat-form-field>
        <mat-label>Patient</mat-label><br>
        <mat-select formControlName="patient" (selectionChange)="onPatientSelected($event)">
          <mat-option *ngFor="let patient of family.patients" [value]="patient.patient">
            {{patient.patient.identifier}} {{getPatientFriendlyName(patient.patient)}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="field">
      <mat-form-field  >
        <mat-label>Compass</mat-label>
        <mat-select  name="bulkSubscriptionId" formControlName="bulkSubscriptionId" >
          <mat-option *ngFor="let bulkSubscription of bulkSubscriptions" [value]="bulkSubscription.id">{{bulkSubscription.compass.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>  

    <div class="field">
      <mat-form-field  >
        <mat-label>Score Level</mat-label>
        <mat-select  name="scoreLevel" formControlName="scoreLevel" >
          <mat-option *ngFor="let scoreLevel of scoreLevels" [value]="scoreLevel">{{scoreLevel}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="field"> 
        <mat-checkbox formControlName="selfAssess" (change)="selfAssessToggle($event)">Self-assess?</mat-checkbox>
    </div>
    <div class="field">
      <mat-form-field  >
        <mat-label>Assessment taker email</mat-label>
       
        <input matInput email formControlName="assessmentTaker" name="assessmentTaker" >
        <mat-hint class="hint" *ngIf="isEditing()">To reaassign the assessment taker, remove this assignment and create a new one.</mat-hint>
      </mat-form-field>
    </div>
  </div>
</div>
<div class="button-container">
  <button *ngIf="isEditing()" class="dialog-button" type="button" (click)="remove()" mat-flat-button color="primary" >Remove</button>
  <button class="dialog-button" [disabled]="isFormInValid()" type="submit" mat-flat-button color="primary" >Save</button>
  <button class="dialog-button" mat-flat-button color="primary" type="reset" (click)="close()">Cancel</button>
</div>

</form>